// Presentation helpers for the ludic avatar cards (FR22–FR25 / Epic 5).
// Pure functions — no rendering — so the two card variants and the pickers
// stay consistent (monogram initials, consciousness labels, matriz lookups).

// PT labels for the `nivel_consciencia` enum (FR23). Rendered in brand.rose.
export const CONSCIOUSNESS_LABELS = {
  inconsciente: "Inconsciente",
  consciente_problema: "Consciente do problema",
  consciente_solucao: "Consciente da solução",
  consciente_produto: "Consciente do produto",
};

export function consciousnessLabel(value) {
  return value ? CONSCIOUSNESS_LABELS[value] || null : null;
}

// Two big initials for the monogram placeholder (replaces the av1-6 PNGs).
export function monogramInitials(nome) {
  if (!nome || !nome.trim()) return "?";
  const parts = nome.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// First item of a matriz axis (jsonb arrays of 10), falling back to the first
// line of the free-text field. Used for the "objetivo"/"dor" labelled rows.
export function matrizFirst(avatar, matrizKey, fallbackField) {
  const m = avatar?.matriz_estrategica;
  if (m && Array.isArray(m[matrizKey]) && m[matrizKey].length) {
    const first = m[matrizKey][0];
    if (first && String(first).trim()) return String(first).trim();
  }
  const fb = avatar?.[fallbackField];
  if (fb && String(fb).trim()) return String(fb).split("\n")[0].trim();
  return null;
}

// "São Paulo, SP · R$ 20-35k" — omits either half when missing.
export function avatarFooterLine(avatar) {
  return [avatar?.localizacao, avatar?.renda_estimada].filter(Boolean).join(" · ");
}

export function secondaryLine(avatar) {
  const primary = avatar?.ocupacao || avatar?.nicho;
  return [primary, avatar?.faixa_etaria].filter(Boolean).join(" · ");
}

function cleanAvatarFact(value) {
  const text = String(value || "").trim();
  return text || null;
}

// A name is useful while an avatar is being edited, but it is not a public
// identifier. Keep all public surfaces grounded in fields collected for the
// avatar instead. `peers` only supplies an ordinal when two factual labels are
// equal; it never contributes an internal id to rendered text.
export function publicAvatarDescription(avatar, peers = []) {
  const facts = [
    cleanAvatarFact(avatar?.ocupacao) || cleanAvatarFact(avatar?.nicho),
    cleanAvatarFact(avatar?.faixa_etaria),
    cleanAvatarFact(avatar?.localizacao),
  ].filter(Boolean).filter((fact, index, all) => all.indexOf(fact) === index);
  const factualDescription = facts.join(" · ");
  const description = (avatar?.status === "draft" && factualDescription
    ? `${factualDescription} · Em configuração` : factualDescription) || (
    avatar?.status === "draft" ? "Público em configuração" : "Público sem detalhes"
  );

  if (!Array.isArray(peers) || peers.length < 2) return description;
  const matching = peers.filter((peer) => publicAvatarDescription(peer) === description)
    .sort((a, b) => String(a?.id || "").localeCompare(String(b?.id || "")));
  if (matching.length < 2) return description;
  const index = matching.findIndex((peer) => peer === avatar || peer?.id === avatar?.id);
  return index < 0 ? description : `${description} · Perfil ${index + 1}`;
}
